import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Option from './_Option'
import { Props, ScoringProps } from './types'

const ScoringSelector = ({ onChange, isLarge, variant = 'viridian' }: ScoringProps) => {
  const [selectedScoring, setSelectedScoring] = useState<number | undefined>(undefined)
  // Array from 0 to 10
  const options = Array.from(Array(11), (_, i) => i)
  const onClick: Props['onChange'] = (option) => {
    const chosen = option === selectedScoring ? undefined : option
    setSelectedScoring(chosen)
    onChange(chosen)
  }

  return (
    <Box flexDirection="row" gap="s8">
      {options.map((option) => (
        <Option
          variant={variant}
          key={option}
          value={option}
          onClick={onClick}
          isSelected={option === selectedScoring}
          isLarge={isLarge}
        />
      ))}
    </Box>
  )
}

const Scoring = ({ onChange, label, large = false, variant = 'viridian' }: Props) => {
  return (
    <Box gap="s24">
      {label && (
        <Text size="300" weight="medium" color="grey1000">
          {label}
        </Text>
      )}
      <ScoringSelector isLarge={large} onChange={onChange} variant={variant} />
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
        <Text size="200" color="grey800">
          {i18n.t('nps.score.limits.lower')}
        </Text>
        <Box flexDirection="row" gap="s2">
          <Text size="200" color="grey800">
            {i18n.t('nps.score.limits.upper')}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

export default Scoring
